import { ProConfigProvider } from '@ant-design/pro-components';
import { useTheme } from '@zhiyue/core';
import { App, ConfigProvider, theme } from 'antd';
import React from 'react';
export function navigationTokens(dark: boolean) {
  const bg = dark ? '#1E1E1E' : '#F0F0F3';
  const text = dark ? 'rgba(255,255,255,0.88)' : '#1F2633';
  const muted = dark ? 'rgba(255,255,255,0.65)' : '#667085';
  return {
    header: {
      heightLayoutHeader: 44,
      colorBgHeader: bg,
      colorHeaderTitle: text,
      colorTextMenu: muted,
      colorTextMenuSelected: text,
      colorTextMenuActive: text,
      colorBgMenuItemSelected: 'transparent',
      colorBgMenuItemHover: 'transparent',
    },
    sider: {
      colorMenuBackground: bg,
      colorTextMenu: muted,
      colorTextMenuSelected: text,
      colorTextMenuActive: text,
      colorBgMenuItemSelected: dark
        ? 'rgba(255,255,255,0.12)'
        : 'rgba(0,0,0,0.06)',
      colorBgMenuItemHover: dark
        ? 'rgba(255,255,255,0.08)'
        : 'rgba(0,0,0,0.04)',
    },
  };
}
export default function ThemeBoundary({
  children,
}: {
  children: React.ReactNode;
}) {
  const { navTheme } = useTheme();
  const dark = navTheme === 'realDark';
  React.useEffect(() => {
    document.documentElement.dataset.theme = dark ? 'dark' : 'light';
  }, [dark]);
  return (
    <ConfigProvider
      theme={{
        algorithm: dark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: '#1677ff',
          borderRadius: 8,
          fontFamily: 'Microsoft YaHei, system-ui, sans-serif',
        },
        components: {
          Button: {
            defaultShadow: 'none',
            primaryShadow: 'none',
            dangerShadow: 'none',
          },
        },
      }}
    >
      <ProConfigProvider dark={dark}>
        <App>{children}</App>
      </ProConfigProvider>
    </ConfigProvider>
  );
}
